<template>
  <v-card
    outlined
    class="catalog-product-card"
    :class="{ 'special-price-card': isSpecialPrice }"
  >
    <div class="product-image-wrap" @click="$emit('image-click', product)">
      <div v-if="isSpecialPrice" class="special-price-ribbon">
        <v-icon small color="white">mdi-fire</v-icon>
        Special Price
      </div>
      <v-img
        v-if="displayImageUrl"
        :src="displayImageUrl"
        :lazy-src="displayImageUrl"
        contain
        height="110"
        class="product-image"
      />

      <v-img
        v-else
        src="@/assets/images/photoComingSoon.png"
        contain
        height="110"
        class="product-image"
      />

      <div v-if="isNewProduct" class="badge new-badge">
        <v-icon size="14" color="white">mdi-flash</v-icon>
        New Product
      </div>

      <v-chip
        v-if="product.lastPurchasedAt"
        x-small
        color="amber darken-3"
        text-color="white"
        class="last-order-chip"
      >
        Last Ordered
      </v-chip>
    </div>

    <div class="product-body">
      <div class="product-name">
        {{ product.name }}
      </div>

      <div class="brand-row">
        <v-chip x-small label v-if="product.Brand">
          {{ product.Brand.name }}
        </v-chip>

        <v-chip x-small label color="error" text-color="white" v-else>
          N/A
        </v-chip>

        <v-chip x-small label> Stock: {{ product.balance || 0 }} </v-chip>
      </div>

      <div class="price-row">
        <div
          v-if="product.dynamicPrice && product.dynamicPrice !== product.price"
          class="dynamic-price"
        >
          {{ product.dynamicPrice | currency }} *
        </div>

        <div v-else-if="product.unitCountInBox && product.unitCountInBox > 0">
          <span class="price-label">Unit:</span>
          <strong>{{
            (product.price / product.unitCountInBox) | currency
          }}</strong>
        </div>

        <div v-else>
          <strong>{{ product.price | currency }}</strong>
        </div>

        <div v-if="product.unitCountInBox" class="unit-count">
          {{ product.unitCountInBox }} / box
        </div>
      </div>
    </div>

    <div class="catalog-qty-row">
      <v-btn
        class="catalog-qty-btn minus"
        depressed
        :disabled="qty <= 0"
        @click.stop="$emit('minus', product)"
      >
        <v-icon>mdi-minus</v-icon>
      </v-btn>

      <button
        class="catalog-qty-value"
        @click.stop="$emit('open-qty', product)"
      >
        {{ qty }}
      </button>

      <v-btn
        class="catalog-qty-btn plus"
        depressed
        :color="buttonColor"
        :dark="darkMode"
        @click.stop="$emit('add', product)"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "CatalogProductCard",

  props: {
    buttonColor: {
      type: String,
      default: "#F0C316",
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      required: true,
    },
    qty: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    displayImageUrl() {
      return this.product.thumbnailUrl || this.product.imageUrl;
    },
    isSpecialPrice() {
      return !!(
        this.product &&
        (this.product.isSpecial ||
          this.product.isSpecialPrice ||
          this.product.specialPrice ||
          this.product.specialPriceAmount ||
          this.product.special)
      );
    },
    isNewProduct() {
      if (this.product.isNew || this.product.newProduct) return true;

      if (!this.product.createdAt) return false;

      const created = new Date(this.product.createdAt);
      const now = new Date();
      const diffDays = (now - created) / (1000 * 60 * 60 * 24);

      return diffDays <= 30;
    },
  },
};
</script>

<style scoped>
.catalog-product-card {
  border-radius: 16px;
  overflow: hidden;
  height: 100%;
  background: #ffffff;
}

.product-image-wrap {
  position: relative;
  cursor: zoom-in;
  background: #f8fafc;
}

.product-image {
  background: #f8fafc;
}

.badge {
  position: absolute;
  top: 8px;
  z-index: 2;
  font-size: 10px;
  font-weight: 900;
  padding: 4px 8px;
  border-radius: 999px;
  color: #ffffff;
  text-transform: uppercase;
}

.new-badge {
  left: 8px;
  background: #16a34a;
  display: flex;
  align-items: center;
  gap: 2px;
}

.special-badge {
  right: 8px;
  background: #dc2626;
}

.last-order-chip {
  position: absolute;
  bottom: 8px;
  left: 8px;
}

.product-body {
  padding: 9px;
}

.product-name {
  font-size: 12px;
  font-weight: 900;
  line-height: 1.25;
  color: #0f172a;
  min-height: 45px;
  max-height: 45px;
  overflow: hidden;
}

.brand-row {
  margin-top: 6px;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}

.price-row {
  margin-top: 7px;
  font-size: 13px;
  color: #0f172a;
}

.price-label,
.unit-count {
  color: #64748b;
  font-size: 11px;
}

.dynamic-price {
  color: #dc2626;
  font-weight: 900;
}

.catalog-qty-row {
  padding: 8px;
  display: grid;
  grid-template-columns: 46px 1fr 46px;
  gap: 8px;
  align-items: center;
}

.catalog-qty-btn {
  height: 44px !important;
  min-width: 44px !important;
  border-radius: 12px !important;
}

.catalog-qty-btn.minus {
  background: #fee2e2 !important;
  color: #dc2626 !important;
}



.catalog-qty-value {
  height: 44px;
  border: 1px solid #0f172a;
  border-radius: 12px;
  background: #ffffff;
  font-size: 18px;
  font-weight: 900;
  color: #0f172a;
}
.special-price-card {
  border: 2px solid #dc2626 !important;
  box-shadow: 0 0 0 1px rgba(220, 38, 38, 0.12);
}

.special-price-ribbon {
  height: 28px;
  background: #dc2626;
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 10px;
  letter-spacing: 0.3px;
}
</style>